
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.954.805a.688.688 0 01.42.633v15.125a.688.688 0 01-1.17.49L5.183 13.1h-2.37A2.062 2.062 0 01.75 11.038V6.927a2.063 2.063 0 012.063-2.063h2.37L9.208.945a.687.687 0 01.746-.141v.001zM9 3.067L5.942 6.045a.688.688 0 01-.48.195h-2.65a.688.688 0 00-.687.688v4.11a.687.687 0 00.688.687h2.65c.18 0 .352.07.48.197L9 14.924V3.067h-.001zM11.902 5.135a.687.687 0 01.966-.11h.002v.001l.004.003.008.006.02.017.062.055c.29.28.543.594.752.938.402.66.79 1.64.79 2.954 0 1.311-.388 2.293-.79 2.953-.16.266-.346.515-.555.744a3.367 3.367 0 01-.28.27l-.01.01s-.615.333-.968-.108a.688.688 0 01.104-.963l.002-.002v.001l.001-.001.025-.022c.195-.192.366-.408.507-.643.288-.474.589-1.212.589-2.24 0-1.028-.301-1.765-.589-2.238a3.273 3.273 0 00-.532-.661h.002a.687.687 0 01-.11-.964z","fill":"#C5CDDC"}}),_c('path',{attrs:{"d":"M14.243 2.275a.688.688 0 10-.857 1.075l.016.014.071.062c.063.058.16.147.275.268.234.243.55.609.868 1.092a7.623 7.623 0 011.263 4.22 7.592 7.592 0 01-1.263 4.214 7.488 7.488 0 01-.867 1.086c-.11.115-.226.225-.346.33l-.017.014a.688.688 0 00.856 1.075l.045-.037.104-.09a8.968 8.968 0 002.863-6.593 8.995 8.995 0 00-1.489-4.974 8.966 8.966 0 00-1.026-1.29 6.851 6.851 0 00-.45-.428l-.03-.026-.01-.008-.005-.003-.001-.001z","fill":"#C5CDDC"}})])
          )
        }
      }
    